import { getAuth } from "firebase/auth";
import { useEffect } from "react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function FetchUserData() {
  useEffect(() => {
    const fetchUser = async () => {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        const token = await user.getIdToken();

        const res = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        const data = await res.json();
        console.log("Fetched user from backend:", data);
      } else {
        console.log("No user is logged in.");
      }
    };

    fetchUser();
  }, []);

  return null;
}

export default FetchUserData;


